import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// import { href } from 'react-router-dom';

// 1. Import your local images from the src/assets folder
// Go up 3 levels: sections -> components -> src -> then into assets
import Kolhapur from  '../../assets/kolhapur.webp';
import Sangli from  '../../assets/sangli.webp';
import Pune from  '../../assets/pune.webp';
import Nashik from  '../../assets/nashik.webp';
import SSC from  '../../assets/sscBoard.webp';
import Nondani from  '../../assets/nondani.webp';
import ambap from '../../assets/ambap.webp';
import bate from '../../assets/bate.webp';


export default function ClientLogos() {
  
  const logos = [
    { name: 'Kolhapur ZP', url: Kolhapur },
    { name: 'Sangil ZP', url: Sangli },
    { name: 'Pune ZP', url: Pune },
    { name: 'Nashik ZP', url: Nashik },
    { name: 'SSC / HSC board', url: SSC },
    { name: 'nondani va mudrank vibhag', url: Nondani },   
    { name: 'Ambap grampanchyat ', url: ambap },   
    { name: 'Dr. Bate', url: bate },   
  ];

  // We duplicate the logos array once to make the infinite scroll loop seamless
  const rollingLogos = [...logos, ...logos, ...logos];

  return (
    <section className="py-5 bg-white text-center">
      <Container>
        <Row className="justify-content-center mb-4">
          <Col md={8}>
            {/* Heading text */}
            <h5 className="font-rozha display-6  text-secondary  fw-bold ">
              Trusted by
            </h5>
          </Col>
        </Row>
      </Container>

      {/* Main Marquee Wrapper Container */}
      <div className="marquee-wrapper overflow-hidden position-relative w-100 py-3">
        <div className="marquee-track d-flex align-items-center">
          
          {rollingLogos.map((logo, index) => (
            <div key={index} className="marquee-item mx-5 flex-shrink-0">
              <img
                src={logo.url} 
                alt={logo.name} 
                className="img-fluid" 
                style={{ 
                  height: '140px', 
                  maxWidth: '140px', 
                  // filter: 'grayscale(100%) opacity(50%)',
                  objectFit: 'contain'
                }} 
              />
              <p className="font-rozha text-success mt-2 ">
                {logo.name}
              </p>
            </div>
          ))} 
        </div>
      </div>
    </section>
  );
}